"use client";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Eye, EyeSlash } from "iconsax-react";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { FieldValues, Path, UseFormReturn } from "react-hook-form";

type Props<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name?: Path<T>;
  label: string;
  placeholder: string;
  rounded?: "full" | "md";
};

function InputPasswordWithReveal<T extends FieldValues>({
  form,
  name = "password" as Path<T>,
  label,
  placeholder,
  rounded,
}: Props<T>) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-sm text-gray-700">{label}</FormLabel>
          <FormControl>
            <div className="relative">
              <Input
                type={showPassword ? "text" : "password"}
                placeholder={placeholder}
                rounded={rounded}
                value={field.value as string}
                onChange={field.onChange}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
              />
              <button
                tabIndex={-1}
                type="button"
                onClick={togglePasswordVisibility}
                className="cursor-pointer absolute aspect-square top-0 text-primary right-2 rtl:right-auto rtl:left-2 bottom-0 flex items-center justify-center"
              >
                {showPassword ? (
                  <Eye size="24" variant="Outline" className="fill-current" />
                ) : (
                  <EyeSlash
                    size="24"
                    variant="Outline"
                    className="fill-current"
                  />
                )}
              </button>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default InputPasswordWithReveal;
